export default "__VITE_ASSET__b3ddilna__"